import { GameObject3D } from '../classes/types'

const getGameElementFromObj = (obj: GameObject3D) => {
  let object: GameObject3D = obj
  while(!Object.hasOwn(object, '__gameObject') && object.type !== 'Scene') {
    object = object.parent as GameObject3D
  }
  if(!Object.hasOwn(object, '__gameObject')) {
    throw new Error('Trying to get __gameObject from a child not belonging to a Game Object')
  }

  return object.__gameObject
}

export default getGameElementFromObj
